import { render, staticRenderFns } from "./ModalCatalogoConsultaPedidos.vue?vue&type=template&id=12dad728"
import script from "./ModalCatalogoConsultaPedidos.vue?vue&type=script&lang=js"
export * from "./ModalCatalogoConsultaPedidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports